import type { MenuSection } from '@botto/core';

export const menu: MenuSection = {
  id: 'tracker',
  title: 'Трекер',
  icon: 'chart',
  items: [
    { title: 'Ссылки', to: '/tracker/links', icon: 'link' },
    { title: 'Домены', to: '/tracker/domains', icon: 'globe' },
    { title: 'Группы', to: '/tracker/groups', icon: 'folder' },
    { title: 'Edge-ноды', to: '/tracker/nodes', icon: 'globe' },
    {
      title: 'Настройки',
      to: '/tracker/settings',
      icon: 'preferences',
      requiresPermission: 'admin:all',
    },
  ],
};
